import {useCallback} from "react";
import {OrganManagerType} from "../../../../../../types/organShare";

export function useOrganManagerAuthorityActions() {
    const organManagerTypes = [
        OrganManagerType.ROLE_ORGAN_MANAGER_SHARE, OrganManagerType.ROLE_ORGAN_MANAGER_SHAREE, OrganManagerType.ROLE_ORGAN_MANAGER
    ]

    const toStringOrganManagerAuthorityTypes = useCallback(
        (type: OrganManagerType) => {
            switch (type) {
                case OrganManagerType.ROLE_ORGAN_MANAGER:
                    return "특정 권한 없음"
                case OrganManagerType.ROLE_ORGAN_MANAGER_SHARE:
                    return "소속 멤버 공유"
                case OrganManagerType.ROLE_ORGAN_MANAGER_SHAREE:
                    return "소속 멤버 공유 받기"
                default:
                    return "특정 권한 없음"
            }
        },[]);

    return{
        organManagerTypes,
        toStringOrganManagerAuthorityTypes
    }
}